export const fontSize = 14;

export const typography = {
    fontSize,
    fontFamily: [
        "NanumSquare",
        "sans-serif",
        "Apple Color Emoji",
        "Segoe UI Emoji",
        '"Segoe UI"',
        "Segoe UI Symbol",
    ].join(","),
    htmlFontSize: 16,
    body1: { fontSize },
    body2: { fontSize },
};
